import { Credit } from "@/interfaces/credit";
import { defineStore } from "pinia";
import { ref } from "vue";

export const useCreditStore = defineStore('credit', () => {

    const credit = ref<Credit | undefined>(undefined)

    return {
        credit,

        setCredit(value: Credit | undefined) {
            credit.value = value
        },
    }

});